<template>
  <!-- 降雨等值面图vue -->
  <div class="jydzm">
    <el-select class="jyselect" v-model="jyValue" placeholder="请选择降雨等值面图时间" @change="jyChange">
      <el-option v-for="item in jiangyuData" :key="item.id" :label="item.name" :value="item.id">
      </el-option>
    </el-select>
    <rainInofDialog v-if="raininfoDialogVisible==true" @cancel="rainCancel" :rainydbInfo="rainydbInfo"></rainInofDialog>
  </div>
</template>
<script>
import {
  totalForRegion,
  GetQB_FORPRGIS,
  GetRainPolygonGeojson,
  clickYDZM,
  insertJYDZM,
  // getYDBJYLTest
} from '@/api/api.js'
import common from "../../common/js/common_val";
import rainInofDialog from "../../views/Basicinformation/rainInofDialog.vue";
import axios from "axios";
export default {
  props: ['ydbgisData'],
  data() {
    return {
      jyValue: '',
      jiangyuData: [],
      jyValue1: '',
      //当前日期
      nowDate: null,
      //降雨面图中包含的ydb
      rainydbInfo: [],
      //降雨等值面图层
      resultLayer: null,
      raininfoDialogVisible: false,
      //降雨面图中包含的ydb
      rainydbInfo: [],
    }
  },
  components: {
    rainInofDialog
  },
  mounted() {
    // this.jyChange(72);
    // this.$store.state.yuShi = 72;

    let data = new Date();
    this.getbyData(data);
  },
  methods: {
    //默认当天往前设置降雨等值面制作日期，取到值为止
    getbyData(data) {
      let _this = this;
      let months = data.getMonth() + 1;
      let days = data.getDate();
      if (months < 10) {
        months = '0' + months;
      }
      if (days < 10) {
        days = '0' + days;
      }
      this.nowDate = data.getFullYear() + months + days + '08';

      let params = {
        stdt: this.nowDate
      };
      GetQB_FORPRGIS(params).then((res) => {
        if (res.length != 0) {
          for (let i = 0; i < res.length; i++) {
            if (res[i].PRTIME == 24) {
              let str = res[i].DT.substr(0, 4) + '年' + res[i].DT.substr(4, 2) + '月' + res[i].DT.substr(6, 2) + '日24h';
              this.jiangyuData.push({
                name: str,
                id: res[i].DT
              })
            }
          }
          this.jyValue = this.jiangyuData[0].name;
          this.jyChange(this.jiangyuData[0].id);

          //系统启动后把所有等值面存入后台
          //判断后台是否存入降雨等值面
          let params1 = {
            paramuu: this.nowDate
          };
          clickYDZM(params1).then((res) => {
            if (res.message == 'NO') {
              console.log(res.message)
              this.$message({
                message: '开始进行降雨等值面数据存入数据库并计算！',
                type: 'success'
              });
              setTimeout(function () {
                _this.insertJYDZMData(_this.jiangyuData)
              }, 1000);
            }
          });
        } else {
          let _this = this;
          let myDate = data.getFullYear() + '-' + months + '-' + days;
          let date1 = new Date(myDate);
          let beforedata = new Date(date1.getTime() - 24 * 60 * 60 * 1000);
          setTimeout(function () {
            _this.getbyData(beforedata);
          }, 1000);
        }
      });
    },
    //系统启动后把所有等值面存入后台，后台判断收不收
    async insertJYDZMData(data) {
      for (let i = 0; i < data.length; i++) {
        let params = {
          STDT: this.nowDate,
          DT: data[i].id,
          PRTIME: '24',
        };
        await GetRainPolygonGeojson(params).then((res) => {
          let obj = JSON.parse(res);
          let param1;
          if (i != data.length - 1) {
            param1 = {
              paramJson: JSON.stringify(obj),
              yuShi: data[i].id,
              paramuu: this.nowDate
            };
          } else {
            param1 = {
              paramJson: JSON.stringify(obj),
              yuShi: data[i].id,
              paramuu: this.nowDate,
              endType: 'YES'
            };
          }
          this.insertjyData(param1);
        });
      }
    },
    async insertjyData(param1) {
      await insertJYDZM(param1).then((res) => {
        console.log(res)
        if (res.message == '保存成功！') {
          this.$message({
            message: '计算并保存成功！',
            type: 'success'
          });
        }
      })
    },

    jyChange(value) {
      // console.log(value)
      // this.map.addLayer(common.jyLayerGroup);
      // common.jyLayerGroup.clearLayers();
      this.$store.state.yuShi = value;
      if (value != '') {
        this.raincontourbyhoursFun1(value);
        this.$store.state.yuShi = value;
      }
    },

    raincontourbyhoursFun1(hours) {
      let _this = this;

      let params = {
        STDT: this.nowDate,
        DT: hours,
        PRTIME: '24',
      };
      // let esri2geo = require('esri2geo');
      GetRainPolygonGeojson(params).then((res) => {
        // console.log(res.data)
        let obj = JSON.parse(res);
        // esri2geo(obj, function(err, data) {
        _this.resultLayer = L.geoJSON(obj, {
          style: function (feature) {
            // console.log(feature)
            if (feature.properties.GRIDCODE == 1) {
              return {
                stroke: false,
                fillColor: '#a5f38d',
                fillOpacity: 0.3
              };
            } else if (feature.properties.GRIDCODE == 2) {
              return {
                stroke: false,
                fillColor: '#39aa00',
                fillOpacity: 0.3
              };
            } else if (feature.properties.GRIDCODE == 3) {
              return {
                stroke: false,
                fillColor: '#63baff',
                fillOpacity: 0.3
              };
            } else if (feature.properties.GRIDCODE == 4) {
              return {
                stroke: false,
                fillColor: '#0000fe',
                fillOpacity: 0.3
              };
            } else if (feature.properties.GRIDCODE == 5) {
              return {
                stroke: false,
                fillColor: '#ff00fe',
                fillOpacity: 0.3
              };
            } else if (feature.properties.GRIDCODE == 6 || feature.properties.GRIDCODE == 7) {
              return {
                stroke: false,
                fillColor: '#720000',
                fillOpacity: 0.3
              };
            } else {
              return {
                stroke: false,
                fill: false
              };
            }
          }
        });

        _this.resultLayer.on('click', function (e) {
          _this.layerClick(e);
        });

        // _this.map.on('popupopen', function({
        //   sourceTarget: popup
        // }) {
        //   if (document.getElementsByClassName("xqbutton")) {
        //     for (let i = 0; i < document.getElementsByClassName('leaflet-popup-content').length; i++) {
        //       document.getElementsByClassName('leaflet-popup-content')[i].style.height = "150px";
        //     }
        //     let popClick = document.getElementsByClassName("xqbutton");
        //     for (let j = 0; j < popClick.length; j++) {
        //       popClick[j].onclick = () => {
        //         _this.raininfoDialogVisible = true;
        //       }
        //     }
        //     let popClose = document.getElementsByClassName("leaflet-popup-close-button");
        //     for (let m = 0; m < popClose.length; m++) {
        //       popClose[m].onclick = () => {
        //         _this.$store.state.dzmcxStatus = false;
        //         let ydbcodegroup = [];
        //         for (let i = 0; i < _this.ydbgisData.length; i++) {
        //           ydbcodegroup.push(_this.ydbgisData[i].ydbCode);
        //         }
        //         _this.$store.commit('myydbDataFun', ydbcodegroup.toString()); //token
        //       }
        //     }
        //   }
        // })

        // common.jyLayerGroup.addLayer(_this.resultLayer);
        // });
      });
    },

    //图层点击事件
    layerClick(e) {
      let _this = this;
      this.rainydbInfo = [];
      let myData = [];
      for (let i = 0; i < this.ydbgisData.length; i++) {
        let ifinside = this.isPointInPolygon(this.ydbgisData[i].ydbJingDu, this.ydbgisData[i]
          .ydbWeiDu, e.layer._latlngs[0]);
        if (ifinside == true) {
          myData.push(this.ydbgisData[i]);
          this.rainydbInfo.push(this.ydbgisData[i].ydbCode);
        }
      }
      if (e.layer._latlngs.length > 1) {
        for (let m = 1; m < e.layer._latlngs.length; m++) {
          for (let n = 0; n < myData.length; n++) {
            let ifinside = this.isPointInPolygon(myData[n].ydbJingDu, myData[n]
              .ydbWeiDu, e.layer._latlngs[m]);
            if (ifinside == true) {
              let index = this.rainydbInfo.indexOf(myData[n].ydbCode)
              if (index > -1) this.rainydbInfo.splice(index, 1);
            }
          }
        }
      }

      this.$store.state.dzmcxStatus = true;
      this.$store.commit('myydbDataFun', this.rainydbInfo.toString()); //token

      //调用接口获取影响人数和重要设施数
      let yxrsNum = 0;
      let zyssNum = 0;
      let params = {
        regionCode: this.$store.state.nowxingzhengCode,
        ydbCodeList: this.rainydbInfo.toString()
      };
      if (this.rainydbInfo.length != 0) {
        totalForRegion(params).then((res) => {
          // console.log(res.data)
          if (res.data.length != 0) {
            for (let i = 0; i < res.data.length; i++) {
              yxrsNum += res.data[i].yxrsSum;
              zyssNum += res.data[i].zyssSum;
            }
            let content = '影响淤地坝数量：' + _this.rainydbInfo.length +
              "<br>影响人数：" + yxrsNum + "<br>影响重要设施数：" + zyssNum +
              '<br><button class="xqbutton" style="cursor: pointer;width:95%;">查看详情</button>';
            let popup = L.popup().setLatLng(e.latlng).setContent(content).openOn(_this.map);
          }
        });
      } else {
        let content = '影响淤地坝数量：' + this.rainydbInfo.length +
          "<br>影响人数：" + 0 + "<br>影响重要设施数：" + 0 +
          '<br><button class="xqbutton" style="cursor: pointer;width:95%;">查看详情</button>';
        let popup = L.popup().setLatLng(e.latlng).setContent(content).openOn(this.map);
      }
    },

    //判断点是否在多边形内
    isPointInPolygon(lon, lat, points) {
      let isum = 0,
        iCount;
      let dlon1, dlon2, dlat1, dlat2, dlon;
      if (points.length < 3) return false;
      iCount = points.length;
      for (let i = 0; i < iCount; i++) {
        if (i == iCount - 1) {
          dlon1 = points[i].lng;
          dlat1 = points[i].lat;
          dlon2 = points[0].lng;
          dlat2 = points[0].lat;
        } else {
          dlon1 = points[i].lng;
          dlat1 = points[i].lat;
          dlon2 = points[i + 1].lng;
          dlat2 = points[i + 1].lat;
        }
        if (((lat >= dlat1) && (lat <= dlat2)) || ((lat >= dlat2) && (lat <= dlat1))) {
          if (Math.abs(dlat1 - dlat2) > 0) {
            dlon = dlon1 - ((dlon1 - dlon2) * (dlat1 - lat)) / (dlat1 - dlat2);
            if (dlon < lon) {
              isum++;
            }
          }
        }
      }
      if (isum % 2 != 0) {
        return true;
      }
      return false;
    },

    rainCancel() {
      this.raininfoDialogVisible = false;
    },
  },
}
</script>

<style scoped>
.jydzm {
  width: 100%;
  height: 100%;
}

.jyselect {
  float: right;
  width: 200px;
  max-height: 500px;
  z-index: 1;
  margin-right: 400px;
  margin-top: 10px;
}

>>> .el-input--suffix .el-input__inner {
  color: #fff !important;
  background: transparent;
  //border: 1px solid #00b3fe;
  //background-color: rgba(9, 34, 72, 0.5);
}

>>> .el-select-dropdown {
  background: transparent !important;
  border: 1px solid #00b3fe;
  background-color: rgba(9, 34, 72, 0.5) !important;
}

>>> .el-range-editor.el-input__inner {
  background: transparent;
  background-color: rgba(9, 34, 72, 0.5);
  border: 1px solid #00b3fe;
}

>>> .el-date-editor .el-range-input {
  background: transparent;
  color: #fff;
}

>>> .el-date-editor .el-range-separator {
  color: #ccc;
}
</style>
